import { render, staticRenderFns } from "./MaxLessonWatchCard.vue?vue&type=template&id=3baeb8ca&scoped=true"
import script from "./MaxLessonWatchCard.vue?vue&type=script&lang=ts"
export * from "./MaxLessonWatchCard.vue?vue&type=script&lang=ts"
import style0 from "./MaxLessonWatchCard.vue?vue&type=style&index=0&id=3baeb8ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baeb8ca",
  null
  
)

export default component.exports